import Api from "../axios";

export const updateGameStatus = async (data) => {
  return await Api.put("/Game/Update-Status", data, {
    headers: {
      'Content-Type': 'application/json',
      'ngrok-skip-browser-warning': '1',
    }})
};
